import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';
import { useLocalStorage } from '@/hooks/use-local-storage';
import { useTour } from '@/contexts/TourContext';

export function WelcomeModal() {
  const { tourState, startTour } = useTour();
  const [hasSeenWelcome, setHasSeenWelcome] = useLocalStorage('hasSeenWelcome', false);
  const [isOpen, setIsOpen] = useState(!hasSeenWelcome && !tourState.isDismissed && !tourState.isCompleted);

  const handleSkip = () => {
    setHasSeenWelcome(true);
    setIsOpen(false);
  };

  const handleTakeTour = () => {
    setHasSeenWelcome(true);
    setIsOpen(false);
    startTour();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => {
      if (!open) {
        handleSkip();
      }
    }}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader className="items-center space-y-4">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Sparkles className="h-8 w-8 text-primary" />
          </div>
          <DialogTitle className="text-2xl font-bold text-center">
            Welcome to Resource Scheduler
          </DialogTitle>
          <DialogDescription className="text-center text-base">
            Let us show you around
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-4">
          <p className="text-sm text-muted-foreground">
            This quick tour will help you get started with:
          </p>
          <ul className="space-y-2 text-sm">
            <li className="flex items-start">
              <span className="mr-2 mt-0.5 text-primary">•</span>
              <span>Creating and managing bookings</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2 mt-0.5 text-primary">•</span>
              <span>Viewing your schedule across different calendar views</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2 mt-0.5 text-primary">•</span>
              <span>Navigating the application</span>
            </li>
            <li className="flex items-start">
              <span className="mr-2 mt-0.5 text-primary">•</span>
              <span>Adjusting your settings</span>
            </li>
          </ul>
        </div>

        <DialogFooter className="flex-row gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={handleSkip}
            className="flex-1"
          >
            Skip
          </Button>
          <Button
            onClick={handleTakeTour}
            className="flex-1"
          >
            Take Tour
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
